/**
 * Canonical commercial plan limits.
 *
 * Source: apps/marketing/src/pages/Pricing.tsx comparison table.
 * Marketing presentation may format these values; enforcement reads this file only.
 *
 * Custom roles and Integration API are separate: shops need job titles on every plan;
 * API access stays an Enterprise capability. CSV, XLSX, and PDF export is included
 * on every commercial plan, including Free.
 */
import { COMMERCIAL_PLAN_ORDER } from './commercialOffering.js';
export const COMMERCIAL_PLAN_LIMITS = {
    free: {
        maxBranches: 1,
        maxUsers: 2,
        maxCompletedSalesPerMonth: 100,
        historyMonths: 3,
        maxCustomRoles: 1,
        allowsExport: true,
        allowsMultipleBusinesses: false,
        allowsIntegrationApi: false,
        dedicatedSupport: false,
    },
    starter: {
        maxBranches: 1,
        maxUsers: 4,
        maxCompletedSalesPerMonth: null,
        historyMonths: null,
        maxCustomRoles: 5,
        allowsExport: true,
        allowsMultipleBusinesses: false,
        allowsIntegrationApi: false,
        dedicatedSupport: false,
    },
    growth: {
        maxBranches: 5,
        maxUsers: null,
        maxCompletedSalesPerMonth: null,
        historyMonths: null,
        maxCustomRoles: 10,
        allowsExport: true,
        allowsMultipleBusinesses: false,
        allowsIntegrationApi: false,
        dedicatedSupport: false,
    },
    enterprise: {
        maxBranches: null,
        maxUsers: null,
        maxCompletedSalesPerMonth: null,
        historyMonths: null,
        maxCustomRoles: null,
        allowsExport: true,
        allowsMultipleBusinesses: true,
        allowsIntegrationApi: true,
        dedicatedSupport: true,
    },
};
export function planLimitsForKey(planKey) {
    if (isCommercialPlanKey(planKey)) {
        return COMMERCIAL_PLAN_LIMITS[planKey];
    }
    return COMMERCIAL_PLAN_LIMITS.free;
}
function isCommercialPlanKey(planKey) {
    return planKey in COMMERCIAL_PLAN_LIMITS;
}
export function commercialPlanRank(key) {
    const index = COMMERCIAL_PLAN_ORDER.indexOf(key);
    return index === -1 ? -1 : index;
}
export function formatPlanLimitSummary(planKey) {
    const limits = COMMERCIAL_PLAN_LIMITS[planKey];
    if (planKey === 'enterprise') {
        return 'Custom SLA · Dedicated support';
    }
    const branches = limits.maxBranches === 1
        ? '1 branch'
        : limits.maxBranches === null
            ? 'Unlimited branches'
            : `Up to ${limits.maxBranches} branches`;
    const users = limits.maxUsers === null
        ? 'Unlimited users'
        : limits.maxUsers === 1
            ? '1 user'
            : `Up to ${limits.maxUsers} users`;
    const sales = limits.maxCompletedSalesPerMonth === null
        ? 'Unlimited sales'
        : `${limits.maxCompletedSalesPerMonth} sales / month`;
    return `${branches} · ${users} · ${sales}`;
}
export function historyCutoffForPlan(planKey, now = new Date()) {
    const months = COMMERCIAL_PLAN_LIMITS[planKey].historyMonths;
    if (months === null) {
        return null;
    }
    return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - months, now.getUTCDate()));
}
export function formatComparisonValue(value) {
    if (typeof value === 'boolean')
        return value;
    if (value === null)
        return 'Unlimited';
    return String(value);
}
export function formatCustomRolesLimit(maxCustomRoles) {
    if (maxCustomRoles === null)
        return 'Unlimited';
    if (maxCustomRoles <= 0)
        return false;
    return String(maxCustomRoles);
}
//# sourceMappingURL=planLimits.js.map